import React from "react";
import { FaHandshake, FaUserTie, FaLongArrowAltRight, FaUsers, FaChartBar, FaMedal } from "react-icons/fa";

export default function SponsorsValueStrip() {
  return (
    <section
      className="py-12 md:py-16 bg-gradient-to-r from-snaptrix-blue-50 via-white to-purple-50 border-y border-snaptrix-gray-100"
      aria-labelledby="sponsors-strip-heading"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2
            id="sponsors-strip-heading"
            className="text-2xl md:text-3xl lg:text-4xl font-bold text-snaptrix-gray-700 mb-3"
          >
            Feature your sponsors in every post.
          </h2>
          <p className="text-base md:text-lg text-snaptrix-gray-600 max-w-2xl mx-auto">
            Maintain match ball and player sponsors in one place—included in all posts for the match or the player.
          </p>
        </div>

        {/* One place → Every post flow */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-8 lg:gap-12">
          {/* One place */}
          <div className="flex flex-col items-center text-center p-6 md:p-8 bg-white rounded-xl shadow-lg border border-snaptrix-gray-200 min-w-[200px]">
            <span className="text-sm font-semibold text-snaptrix-blue-600 uppercase tracking-wide mb-4">
              One place
            </span>
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <div className="p-2.5 bg-snaptrix-blue-50 rounded-lg">
                  <FaHandshake className="text-snaptrix-blue-600 text-xl" aria-hidden="true" />
                </div>
                <span className="text-snaptrix-gray-700 font-medium text-left">Match ball sponsors</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="p-2.5 bg-snaptrix-blue-50 rounded-lg">
                  <FaUserTie className="text-snaptrix-blue-600 text-xl" aria-hidden="true" />
                </div>
                <span className="text-snaptrix-gray-700 font-medium text-left">Player sponsors</span>
              </div>
            </div>
          </div>

          {/* Arrow + Auto-included */}
          <div className="flex flex-col items-center gap-2 shrink-0">
            <FaLongArrowAltRight
              className="text-snaptrix-blue-500 text-3xl md:text-4xl rotate-90 md:rotate-0"
              aria-hidden="true"
            />
            <span className="text-xs md:text-sm font-semibold text-snaptrix-gray-600 whitespace-nowrap">
              Auto-included
            </span>
          </div>

          {/* Every post */}
          <div className="flex flex-col items-center text-center p-6 md:p-8 bg-white rounded-xl shadow-lg border border-snaptrix-gray-200 min-w-[200px]">
            <span className="text-sm font-semibold text-purple-600 uppercase tracking-wide mb-4">
              Every post
            </span>
            <div className="flex flex-col gap-2 text-snaptrix-gray-600 text-sm">
              <div className="flex items-center gap-2 justify-center">
                <FaUsers className="text-snaptrix-blue-500 shrink-0" aria-hidden="true" />
                <span>Team announcement</span>
              </div>
              <div className="flex items-center gap-2 justify-center">
                <FaChartBar className="text-purple-500 shrink-0" aria-hidden="true" />
                <span>Match summary</span>
              </div>
              <div className="flex items-center gap-2 justify-center">
                <FaMedal className="text-amber-500 shrink-0" aria-hidden="true" />
                <span>Top performance</span>
              </div>
              <span className="text-snaptrix-gray-500 text-xs mt-1">…and all match & player posts</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
